import {
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$7ps311k1ff73 as LinkedHashMap_init_$Create$,
  Unit_instance104q5opgivhr8 as Unit_instance,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  enumEntries20mr21zbe3az4 as enumEntries,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  CancellationException_init_$Create$35hy9ztjr481d as CancellationException_init_$Create$,
  CancellationException3b36o9qz53rgr as CancellationException,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  toString30pk9tzaqopn as toString_0,
  toLongw1zpgk99d84b as toLong,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  joinToString1cxrrlmo0chqs as joinToString,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$1f5sozasf31ba as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  defineProp3hxgpk2knu2px as defineProp,
  compareTo3ankvs086tmwq as compareTo,
  decodeToString1dbzcjd620q25 as decodeToString,
  Randomei1bbeye8rr8 as Random,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$_0,
  split2bvyvnrlcifjv as split,
  first58ocm7j58k3q as first,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  drop3na99dw9feawf as drop,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Dispatchers_getInstance1nk2l7rcqz5wi as Dispatchers_getInstance,
  launch1c91vkjzdi9sd as launch,
  CoroutineStart_UNDISPATCHED_getInstance2fi8udegl4ge1 as CoroutineStart_UNDISPATCHED_getInstance,
  ChannelResult2y4k69ac6y3du as ChannelResult,
  _ChannelResult___get_isSuccess__impl__odq1z912klyyef6kn9b as _ChannelResult___get_isSuccess__impl__odq1z9,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  cancelConsumed2i0oizqhmljf6 as cancelConsumed,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
  Channel3r72atmcithql as Channel,
  Key_instance3o7pj7ik1b183 as Key_instance,
  Job13y4jkazwjho0 as Job,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  CopyableThrowable1mvc99jcyvivf as CopyableThrowable,
  withTimeoutOrNull30gvkflmp8gj3 as withTimeoutOrNull,
} from './kotlinx-coroutines-core.mjs';
import {
  get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled,
  ChannelIOException2i3t76lsrbgox as ChannelIOException,
  KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger,
  initCauseBridge1upxfqhavblt6 as initCauseBridge,
  getTimeMillis12o7k17x9fmwi as getTimeMillis,
  hex2ofqpe9ngcu1i as hex,
} from './ktor-ktor-utils.mjs';
import {
  BytePacketBuilder2biodf4wxvlba as BytePacketBuilder,
  writeFully359t6q8kam2g5 as writeFully,
  buildjygoh729rhy8 as build,
  get_size2imoy2jq11jxl as get_size,
  Charsets_getInstancemd62gu5po4os as Charsets_getInstance,
  decode1t43jmuxrxpmo as decode,
  readText27783kyxjxi1g as readText,
  toByteArray1i3ns5jnoqlv6 as toByteArray,
  ClosedByteChannelException3il8gfpye60w as ClosedByteChannelException,
  writeText19qfzm98fbm4l as writeText,
} from './ktor-ktor-io.mjs';
import {
  readByteArray1ri21h2rciakw as readByteArray,
  IOException_init_$Create$13y6ig657l2av as IOException_init_$Create$,
  Buffergs925ekssbch as Buffer,
} from './kotlinx-io-kotlinx-io-core.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
} from './kotlinx-atomicfu.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Codes, 'Codes', VOID, Enum);
initMetadataForClass(CloseReason, 'CloseReason');
function send(frame, $completion) {
  return this.c4e().o1w(frame, $completion);
}
initMetadataForInterface(WebSocketSession, 'WebSocketSession', VOID, VOID, [CoroutineScope], [1, 0]);
initMetadataForInterface(DefaultWebSocketSession, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
initMetadataForCompanion(Companion_0);
initMetadataForLambda(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($outgoingProcessorLoopCOROUTINE$0, CoroutineImpl);
initMetadataForCoroutine($sendCloseSequenceCOROUTINE$1, CoroutineImpl);
initMetadataForCoroutine($checkMaxFrameSizeCOROUTINE$2, CoroutineImpl);
initMetadataForClass(DefaultWebSocketSessionImpl, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession, WebSocketSession], [1, 0, 2]);
initMetadataForObject(NonDisposableHandle, 'NonDisposableHandle');
initMetadataForClass(FrameTooBigException, 'FrameTooBigException', VOID, Exception, [Exception, CopyableThrowable]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(FrameType, 'FrameType', VOID, Enum);
initMetadataForLambda(ponger$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(pinger$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(pinger$slambda$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(pinger$slambda, CoroutineImpl, VOID, [1]);
initMetadataForInterface(WebSocketExtension, 'WebSocketExtension');
initMetadataForClass(WebSocketExtensionsConfig, 'WebSocketExtensionsConfig', WebSocketExtensionsConfig);
initMetadataForClass(WebSocketExtensionHeader, 'WebSocketExtensionHeader');
initMetadataForCoroutine($closeCOROUTINE$3, CoroutineImpl);
initMetadataForClass(Frame, 'Frame');
initMetadataForClass(Binary, 'Binary', VOID, Frame);
initMetadataForClass(Text, 'Text', VOID, Frame);
initMetadataForClass(Close, 'Close', Close_init_$Create$_0, Frame);
initMetadataForClass(Ping, 'Ping', VOID, Frame);
initMetadataForClass(Pong, 'Pong', VOID, Frame);
initMetadataForCompanion(Companion_2);
//endregion
var Codes_NORMAL_instance;
var Codes_GOING_AWAY_instance;
var Codes_PROTOCOL_ERROR_instance;
var Codes_CANNOT_ACCEPT_instance;
var Codes_CLOSED_ABNORMALLY_instance;
var Codes_NOT_CONSISTENT_instance;
var Codes_VIOLATED_POLICY_instance;
var Codes_TOO_BIG_instance;
var Codes_NO_EXTENSION_instance;
var Codes_INTERNAL_ERROR_instance;
var Codes_SERVICE_RESTART_instance;
var Codes_TRY_AGAIN_LATER_instance;
function Companion() {
  Companion_instance = this;
  var tmp = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = get_entries();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$0 = element.r4d_1;
    destination.h2(tmp$ret$0, element);
  }
  tmp.s4d_1 = destination;
  this.t4d_1 = Codes_INTERNAL_ERROR_getInstance();
}
protoOf(Companion).u4d = function (code) {
  return this.s4d_1.a2(code);
};
var Companion_instance;
function Companion_getInstance() {
  Codes_initEntries();
  if (Companion_instance == null)
    new Companion();
  return Companion_instance;
}
function values() {
  return [Codes_NORMAL_getInstance(), Codes_GOING_AWAY_getInstance(), Codes_PROTOCOL_ERROR_getInstance(), Codes_CANNOT_ACCEPT_getInstance(), Codes_CLOSED_ABNORMALLY_getInstance(), Codes_NOT_CONSISTENT_getInstance(), Codes_VIOLATED_POLICY_getInstance(), Codes_TOO_BIG_getInstance(), Codes_NO_EXTENSION_getInstance(), Codes_INTERNAL_ERROR_getInstance(), Codes_SERVICE_RESTART_getInstance(), Codes_TRY_AGAIN_LATER_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var Codes_entriesInitialized;
function Codes_initEntries() {
  if (Codes_entriesInitialized)
    return Unit_instance;
  Codes_entriesInitialized = true;
  Codes_NORMAL_instance = new Codes('NORMAL', 0, 1000);
  Codes_GOING_AWAY_instance = new Codes('GOING_AWAY', 1, 1001);
  Codes_PROTOCOL_ERROR_instance = new Codes('PROTOCOL_ERROR', 2, 1002);
  Codes_CANNOT_ACCEPT_instance = new Codes('CANNOT_ACCEPT', 3, 1003);
  Codes_CLOSED_ABNORMALLY_instance = new Codes('CLOSED_ABNORMALLY', 4, 1006);
  Codes_NOT_CONSISTENT_instance = new Codes('NOT_CONSISTENT', 5, 1007);
  Codes_VIOLATED_POLICY_instance = new Codes('VIOLATED_POLICY', 6, 1008);
  Codes_TOO_BIG_instance = new Codes('TOO_BIG', 7, 1009);
  Codes_NO_EXTENSION_instance = new Codes('NO_EXTENSION', 8, 1010);
  Codes_INTERNAL_ERROR_instance = new Codes('INTERNAL_ERROR', 9, 1011);
  Codes_SERVICE_RESTART_instance = new Codes('SERVICE_RESTART', 10, 1012);
  Codes_TRY_AGAIN_LATER_instance = new Codes('TRY_AGAIN_LATER', 11, 1013);
  Companion_getInstance();
}
var $ENTRIES;
function CloseReason_init_$Init$(code, message, $this) {
  CloseReason.call($this, code.r4d_1, message);
  return $this;
}
function CloseReason_init_$Create$(code, message) {
  return CloseReason_init_$Init$(code, message, objectCreate(protoOf(CloseReason)));
}
function Codes(name, ordinal, code) {
  Enum.call(this, name, ordinal);
  this.r4d_1 = code;
}
function Codes_NORMAL_getInstance() {
  Codes_initEntries();
  return Codes_NORMAL_instance;
}
function Codes_GOING_AWAY_getInstance() {
  Codes_initEntries();
  return Codes_GOING_AWAY_instance;
}
function Codes_PROTOCOL_ERROR_getInstance() {
  Codes_initEntries();
  return Codes_PROTOCOL_ERROR_instance;
}
function Codes_CANNOT_ACCEPT_getInstance() {
  Codes_initEntries();
  return Codes_CANNOT_ACCEPT_instance;
}
function Codes_CLOSED_ABNORMALLY_getInstance() {
  Codes_initEntries();
  return Codes_CLOSED_ABNORMALLY_instance;
}
function Codes_NOT_CONSISTENT_getInstance() {
  Codes_initEntries();
  return Codes_NOT_CONSISTENT_instance;
}
function Codes_VIOLATED_POLICY_getInstance() {
  Codes_initEntries();
  return Codes_VIOLATED_POLICY_instance;
}
function Codes_TOO_BIG_getInstance() {
  Codes_initEntries();
  return Codes_TOO_BIG_instance;
}
function Codes_NO_EXTENSION_getInstance() {
  Codes_initEntries();
  return Codes_NO_EXTENSION_instance;
}
function Codes_INTERNAL_ERROR_getInstance() {
  Codes_initEntries();
  return Codes_INTERNAL_ERROR_instance;
}
function Codes_SERVICE_RESTART_getInstance() {
  Codes_initEntries();
  return Codes_SERVICE_RESTART_instance;
}
function Codes_TRY_AGAIN_LATER_getInstance() {
  Codes_initEntries();
  return Codes_TRY_AGAIN_LATER_instance;
}
function CloseReason(code, message) {
  this.v4d_1 = code;
  this.w4d_1 = message;
}
protoOf(CloseReason).x4d = function () {
  return Companion_getInstance().u4d(this.v4d_1);
};
protoOf(CloseReason).toString = function () {
  var tmp0_elvis_lhs = this.x4d();
  return 'CloseReason(reason=' + toString(tmp0_elvis_lhs == null ? this.v4d_1 : tmp0_elvis_lhs) + ', message=' + this.w4d_1 + ')';
};
protoOf(CloseReason).hashCode = function () {
  var result = this.v4d_1;
  result = imul(result, 31) + getStringHashCode(this.w4d_1) | 0;
  return result;
};
protoOf(CloseReason).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CloseReason))
    return false;
  var tmp0_other_with_cast = other instanceof CloseReason ? other : THROW_CCE();
  if (!(this.v4d_1 === tmp0_other_with_cast.v4d_1))
    return false;
  if (!(this.w4d_1 === tmp0_other_with_cast.w4d_1))
    return false;
  return true;
};
function get_LOGGER() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return LOGGER;
}
var LOGGER;
function get_IncomingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return IncomingProcessorCoroutineName;
}
var IncomingProcessorCoroutineName;
function get_OutgoingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return OutgoingProcessorCoroutineName;
}
var OutgoingProcessorCoroutineName;
function get_NORMAL_CLOSE() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return NORMAL_CLOSE;
}
var NORMAL_CLOSE;
function DefaultWebSocketSession() {
}
function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis) {
  pingIntervalMillis = pingIntervalMillis === VOID ? new Long(0, 0) : pingIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? new Long(15000, 0) : timeoutMillis;
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  // Inline function 'kotlin.require' call
  if (!!isInterface(session, DefaultWebSocketSession)) {
    var message = 'Cannot wrap other DefaultWebSocketSession';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return new DefaultWebSocketSessionImpl(session, pingIntervalMillis, timeoutMillis);
}
function runIncomingProcessor($this, ponger) {
  var tmp = get_IncomingProcessorCoroutineName().jg(Dispatchers_getInstance().b1p_1);
  return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0($this, ponger, null));
}
function runOutgoingProcessor($this) {
  var tmp = get_OutgoingProcessorCoroutineName().jg(Dispatchers_getInstance().b1p_1);
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0($this, null));
}
function outgoingProcessorLoop($this, $completion) {
  var tmp = new $outgoingProcessorLoopCOROUTINE$0($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function sendCloseSequence($this, reason, exception, $completion) {
  var tmp = new $sendCloseSequenceCOROUTINE$1($this, reason, exception, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function sendCloseSequence$default($this, reason, exception, $completion, $super) {
  exception = exception === VOID ? null : exception;
  return sendCloseSequence($this, reason, exception, $completion);
}
function tryClose($this) {
  return $this.k4f_1.atomicfu$compareAndSet(false, true);
}
function runOrCancelPinger($this) {
  var interval = $this.p4f_1;
  var tmp;
  if ($this.k4f_1.kotlinx$atomicfu$value) {
    tmp = null;
  } else if (interval.b1(new Long(0, 0)) > 0) {
    var tmp_0 = $this.f4f_1.c4e();
    var tmp_1 = $this.q4f_1;
    tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0($this, null));
  } else {
    tmp = null;
  }
  var newPinger = tmp;
  var tmp0_safe_receiver = $this.g4f_1.atomicfu$getAndSet(newPinger);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.w1w();
  var tmp2_safe_receiver = newPinger == null ? null : new ChannelResult(newPinger.p1w(Companion_getInstance_0().s4f_1));
  if (tmp2_safe_receiver == null)
    null;
  else
    _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.d1u_1);
  if ($this.k4f_1.kotlinx$atomicfu$value && !(newPinger == null)) {
    runOrCancelPinger($this);
  }
}
function checkMaxFrameSize($this, packet, frame, $completion) {
  var tmp = new $checkMaxFrameSizeCOROUTINE$2($this, packet, frame, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function processIncomingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.f4g().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var current = accumulator;
    accumulator = element.g4g(current);
  }
  return accumulator;
}
function processOutgoingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.f4g().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var current = accumulator;
    accumulator = element.h4g(current);
  }
  return accumulator;
}
function Companion_0() {
  Companion_instance_0 = this;
  this.s4f_1 = new Pong(new Int8Array(0), NonDisposableHandle_instance);
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 == null)
    new Companion_0();
  return Companion_instance_0;
}
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation) {
  this.q4g_1 = this$0;
  this.r4g_1 = $ponger;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 39;
          this.t4g_1 = null;
          this.u4g_1 = null;
          this.v4g_1 = false;
          this.w4g_1 = Unit_instance;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.o8_1 = 33;
          this.o8_1 = 32;
          var tmp_0 = this;
          tmp_0.y4g_1 = this.q4g_1.f4f_1.b4e();
          this.z4g_1 = this.y4g_1;
          var tmp_1 = this;
          tmp_1.a4h_1 = this.z4g_1;
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.c4h_1 = this.a4h_1;
          this.d4h_1 = null;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.o8_1 = 29;
          this.o8_1 = 28;
          var tmp_2 = this;
          tmp_2.g4h_1 = this.c4h_1;
          this.h4h_1 = this.g4h_1;
          this.i4h_1 = this.h4h_1.j();
          this.n8_1 = 7;
          continue $sm;
        case 7:
          this.n8_1 = 8;
          suspendResult = this.i4h_1.v1t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 8:
          if (!suspendResult) {
            this.n8_1 = 26;
            continue $sm;
          }

          this.j4h_1 = this.i4h_1.l();
          var tmp_3 = this;
          tmp_3.k4h_1 = this.j4h_1;
          this.n8_1 = 9;
          continue $sm;
        case 9:
          this.m4h_1 = this.k4h_1;
          var this_0 = get_LOGGER();
          if (get_isTraceEnabled(this_0)) {
            this_0.o3u('WebSocketSession(' + toString(this.s4g_1) + ') receiving frame ' + this.m4h_1.toString());
          }

          this.n4h_1 = this.m4h_1;
          var tmp_4 = this.n4h_1;
          if (tmp_4 instanceof Close) {
            if (!this.q4g_1.c4e().x1t()) {
              this.n8_1 = 18;
              var tmp_5 = this.q4g_1.c4e();
              var tmp1_elvis_lhs = readReason(this.m4h_1);
              suspendResult = tmp_5.o1w(Close_init_$Create$(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n8_1 = 19;
              continue $sm;
            }
          } else {
            var tmp_6 = this.n4h_1;
            if (tmp_6 instanceof Pong) {
              this.p4h_1 = this.q4g_1.g4f_1.kotlinx$atomicfu$value;
              if (this.p4h_1 == null) {
                this.q4h_1 = null;
                this.n8_1 = 17;
                continue $sm;
              } else {
                this.n8_1 = 16;
                suspendResult = this.p4h_1.o1w(this.m4h_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_7 = this.n4h_1;
              if (tmp_7 instanceof Ping) {
                this.n8_1 = 15;
                suspendResult = this.r4g_1.o1w(this.m4h_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                this.n8_1 = 10;
                suspendResult = checkMaxFrameSize(this.q4g_1, this.u4g_1, this.m4h_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            }
          }

        case 10:
          if (!this.m4h_1.y4h_1) {
            if (this.t4g_1 == null) {
              this.t4g_1 = this.m4h_1;
            }
            if (this.u4g_1 == null) {
              this.u4g_1 = BytePacketBuilder();
            }
            writeFully(ensureNotNull(this.u4g_1), this.m4h_1.a4i_1);
            this.l4h_1 = Unit_instance;
            this.n8_1 = 21;
            continue $sm;
          } else {
            this.n8_1 = 11;
            continue $sm;
          }

        case 11:
          if (this.t4g_1 == null) {
            this.n8_1 = 14;
            suspendResult = this.q4g_1.i4f_1.o1w(processIncomingExtensions(this.q4g_1, this.m4h_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 12;
            continue $sm;
          }

        case 12:
          writeFully(ensureNotNull(this.u4g_1), this.m4h_1.a4i_1);
          this.r4h_1 = Companion_getInstance_2().g4i(true, ensureNotNull(this.t4g_1).z4h_1, readByteArray(build(ensureNotNull(this.u4g_1))), ensureNotNull(this.t4g_1).c4i_1, ensureNotNull(this.t4g_1).d4i_1, ensureNotNull(this.t4g_1).e4i_1);
          this.t4g_1 = null;
          this.n8_1 = 13;
          suspendResult = this.q4g_1.i4f_1.o1w(processIncomingExtensions(this.q4g_1, this.r4h_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 13:
          var tmp_8 = this;
          tmp_8.o4h_1 = Unit_instance;
          this.n8_1 = 20;
          continue $sm;
        case 14:
          this.l4h_1 = Unit_instance;
          this.n8_1 = 21;
          continue $sm;
        case 15:
          var tmp_9 = this;
          tmp_9.o4h_1 = Unit_instance;
          this.n8_1 = 20;
          continue $sm;
        case 16:
          var tmp_10 = this;
          tmp_10.q4h_1 = Unit_instance;
          this.n8_1 = 17;
          continue $sm;
        case 17:
          this.o4h_1 = this.q4h_1;
          this.n8_1 = 20;
          continue $sm;
        case 18:
          this.n8_1 = 19;
          continue $sm;
        case 19:
          this.v4g_1 = true;
          this.f4h_1 = Unit_instance;
          this.n8_1 = 22;
          var tmp_11 = this;
          continue $sm;
        case 20:
          this.l4h_1 = Unit_instance;
          if (false) {
            this.n8_1 = 9;
            continue $sm;
          }

          this.n8_1 = 21;
          continue $sm;
        case 21:
          this.n8_1 = 7;
          continue $sm;
        case 22:
          this.o8_1 = 32;
          var tmp_12 = this;
          cancelConsumed(this.c4h_1, this.d4h_1);
          tmp_12.x4g_1 = Unit_instance;
          this.o8_1 = 39;
          this.n8_1 = 23;
          continue $sm;
        case 23:
          this.o8_1 = 39;
          this.r4g_1.w1w();
          var tmp0_safe_receiver = this.u4g_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.a4();
          }

          this.q4g_1.i4f_1.w1w();
          if (!this.v4g_1) {
            this.n8_1 = 24;
            suspendResult = close(this.q4g_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 25;
            continue $sm;
          }

        case 24:
          this.n8_1 = 25;
          continue $sm;
        case 25:
          var tmp_13 = this;
          return Unit_instance;
        case 26:
          var tmp_14 = this;
          tmp_14.e4h_1 = Unit_instance;
          this.n8_1 = 27;
          var tmp_15 = this;
          continue $sm;
        case 27:
          this.o8_1 = 32;
          var tmp_16 = this;
          cancelConsumed(this.c4h_1, this.d4h_1);
          tmp_16.b4h_1 = Unit_instance;
          this.n8_1 = 31;
          continue $sm;
        case 28:
          this.o8_1 = 29;
          var tmp_17 = this.q8_1;
          if (tmp_17 instanceof Error) {
            this.s4h_1 = this.q8_1;
            var tmp_18 = this;
            this.d4h_1 = this.s4h_1;
            throw this.s4h_1;
          } else {
            throw this.q8_1;
          }

        case 29:
          this.o8_1 = 32;
          this.t4h_1 = this.q8_1;
          cancelConsumed(this.c4h_1, this.d4h_1);
          throw this.t4h_1;
        case 30:
          this.o8_1 = 32;
          cancelConsumed(this.c4h_1, this.d4h_1);
          if (false) {
            this.n8_1 = 3;
            continue $sm;
          }

          this.n8_1 = 31;
          continue $sm;
        case 31:
          this.w4g_1 = Unit_instance;
          this.o8_1 = 39;
          this.n8_1 = 36;
          continue $sm;
        case 32:
          this.o8_1 = 33;
          var tmp_19 = this.q8_1;
          if (tmp_19 instanceof ClosedSendChannelException) {
            this.u4h_1 = this.q8_1;
            var tmp_20 = this;
            tmp_20.w4g_1 = Unit_instance;
            this.o8_1 = 39;
            this.n8_1 = 36;
            continue $sm;
          } else {
            var tmp_21 = this.q8_1;
            if (tmp_21 instanceof Error) {
              this.v4h_1 = this.q8_1;
              var tmp_22 = this;
              this.r4g_1.w1w();
              tmp_22.w4g_1 = this.q4g_1.i4f_1.u1w(this.v4h_1);
              this.o8_1 = 39;
              this.n8_1 = 36;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 33:
          this.o8_1 = 39;
          this.w4h_1 = this.q8_1;
          this.r4g_1.w1w();
          var tmp0_safe_receiver_0 = this.u4g_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.a4();
          }

          this.q4g_1.i4f_1.w1w();
          if (!this.v4g_1) {
            this.n8_1 = 34;
            suspendResult = close(this.q4g_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 35;
            continue $sm;
          }

        case 34:
          this.n8_1 = 35;
          continue $sm;
        case 35:
          throw this.w4h_1;
        case 36:
          this.x4h_1 = this.w4g_1;
          this.o8_1 = 39;
          this.r4g_1.w1w();
          var tmp0_safe_receiver_1 = this.u4g_1;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.a4();
          }

          this.q4g_1.i4f_1.w1w();
          if (!this.v4g_1) {
            this.n8_1 = 37;
            suspendResult = close(this.q4g_1, CloseReason_init_$Create$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 38;
            continue $sm;
          }

        case 37:
          this.n8_1 = 38;
          continue $sm;
        case 38:
          return Unit_instance;
        case 39:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 39) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DefaultWebSocketSessionImpl$runIncomingProcessor$slambda).s3m = function ($this$launch, completion) {
  var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this.q4g_1, this.r4g_1, completion);
  i.s4g_1 = $this$launch;
  return i;
};
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda_0(this$0, $ponger, resultContinuation) {
  var i = new DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation) {
  this.p4i_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 10;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 6;
          this.o8_1 = 3;
          this.n8_1 = 2;
          suspendResult = outgoingProcessorLoop(this.p4i_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.r4i_1 = suspendResult;
          this.o8_1 = 10;
          this.n8_1 = 8;
          continue $sm;
        case 3:
          this.o8_1 = 6;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof ClosedSendChannelException) {
            this.s4i_1 = this.q8_1;
            var tmp_1 = this;
            tmp_1.r4i_1 = Unit_instance;
            this.o8_1 = 10;
            this.n8_1 = 8;
            continue $sm;
          } else {
            var tmp_2 = this.q8_1;
            if (tmp_2 instanceof ClosedReceiveChannelException) {
              this.t4i_1 = this.q8_1;
              var tmp_3 = this;
              tmp_3.r4i_1 = Unit_instance;
              this.o8_1 = 10;
              this.n8_1 = 8;
              continue $sm;
            } else {
              var tmp_4 = this.q8_1;
              if (tmp_4 instanceof CancellationException) {
                this.u4i_1 = this.q8_1;
                this.n8_1 = 4;
                suspendResult = sendCloseSequence$default(this.p4i_1, CloseReason_init_$Create$(Codes_NORMAL_getInstance(), ''), VOID, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_5 = this.q8_1;
                if (tmp_5 instanceof ChannelIOException) {
                  this.v4i_1 = this.q8_1;
                  var tmp_6 = this;
                  tmp_6.r4i_1 = Unit_instance;
                  this.o8_1 = 10;
                  this.n8_1 = 8;
                  continue $sm;
                } else {
                  var tmp_7 = this.q8_1;
                  if (tmp_7 instanceof Error) {
                    this.w4i_1 = this.q8_1;
                    this.p4i_1.j4f_1.r1f(CancellationException_init_$Create$('Failed to send frame', this.w4i_1));
                    this.n8_1 = 5;
                    suspendResult = closeExceptionally(this.p4i_1.f4f_1, this.w4i_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    throw this.q8_1;
                  }
                }
              }
            }
          }

        case 4:
          this.r4i_1 = suspendResult;
          this.o8_1 = 10;
          this.n8_1 = 8;
          continue $sm;
        case 5:
          this.r4i_1 = suspendResult;
          this.o8_1 = 10;
          this.n8_1 = 8;
          continue $sm;
        case 6:
          this.o8_1 = 10;
          this.x4i_1 = this.q8_1;
          this.p4i_1.j4f_1.y1w();
          this.n8_1 = 7;
          suspendResult = close(this.p4i_1.f4f_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 7:
          throw this.x4i_1;
        case 8:
          this.o8_1 = 10;
          this.p4i_1.j4f_1.y1w();
          this.n8_1 = 9;
          suspendResult = close(this.p4i_1.f4f_1, VOID, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 9:
          return Unit_instance;
        case 10:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 10) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda).s3m = function ($this$launch, completion) {
  var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this.p4i_1, completion);
  i.q4i_1 = $this$launch;
  return i;
};
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda_0(this$0, resultContinuation) {
  var i = new DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation) {
  this.g4j_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).i4j = function (it, $completion) {
  var tmp = this.j4j(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).h9 = function (p1, $completion) {
  return this.i4j(p1 instanceof CloseReason ? p1 : THROW_CCE(), $completion);
};
protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = sendCloseSequence(this.g4j_1, this.h4j_1, IOException_init_$Create$('Ping timeout'), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(DefaultWebSocketSessionImpl$runOrCancelPinger$slambda).j4j = function (it, completion) {
  var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this.g4j_1, completion);
  i.h4j_1 = it;
  return i;
};
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda_0(this$0, resultContinuation) {
  var i = new DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.i4j(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function $outgoingProcessorLoopCOROUTINE$0(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m4e_1 = _this__u8e3s4;
}
protoOf($outgoingProcessorLoopCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.n4e_1 = this.m4e_1.j4f_1.j();
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.n8_1 = 2;
          suspendResult = this.n4e_1.v1t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          if (!suspendResult) {
            this.n8_1 = 6;
            continue $sm;
          }

          this.o4e_1 = this.n4e_1.l();
          var this_0 = get_LOGGER();
          if (get_isTraceEnabled(this_0)) {
            this_0.o3u('Sending ' + this.o4e_1.toString() + ' from session ' + toString(this.m4e_1));
          }

          this.p4e_1 = this.o4e_1;
          var tmp_0 = this.p4e_1;
          if (tmp_0 instanceof Close) {
            this.n8_1 = 3;
            suspendResult = sendCloseSequence$default(this.m4e_1, readReason(this.o4e_1), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            var tmp_1;
            var tmp_2 = this.p4e_1;
            if (tmp_2 instanceof Text) {
              tmp_1 = true;
            } else {
              var tmp_3 = this.p4e_1;
              tmp_1 = tmp_3 instanceof Binary;
            }
            if (tmp_1) {
              this.q4e_1 = processOutgoingExtensions(this.m4e_1, this.o4e_1);
              this.n8_1 = 4;
              continue $sm;
            } else {
              this.q4e_1 = this.o4e_1;
              this.n8_1 = 4;
              continue $sm;
            }
          }

        case 3:
          this.n8_1 = 6;
          var tmp_4 = this;
          continue $sm;
        case 4:
          this.r4e_1 = this.q4e_1;
          this.n8_1 = 5;
          suspendResult = this.m4e_1.f4f_1.c4e().o1w(this.r4e_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.n8_1 = 1;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $sendCloseSequenceCOROUTINE$1(_this__u8e3s4, reason, exception, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.a4f_1 = _this__u8e3s4;
  this.b4f_1 = reason;
  this.c4f_1 = exception;
}
protoOf($sendCloseSequenceCOROUTINE$1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          if (!tryClose(this.a4f_1))
            return Unit_instance;
          var this_0 = get_LOGGER();
          if (get_isTraceEnabled(this_0)) {
            this_0.o3u('Sending Close Sequence for session ' + toString(this.a4f_1) + ' with reason ' + toString_0(this.b4f_1) + ' and exception ' + toString_0(this.c4f_1));
          }

          this.a4f_1.l4f_1.e1l();
          var tmp_0 = this;
          var tmp0_elvis_lhs = this.b4f_1;
          tmp_0.d4f_1 = tmp0_elvis_lhs == null ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : tmp0_elvis_lhs;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.o8_1 = 5;
          runOrCancelPinger(this.a4f_1);
          if (!(this.d4f_1.v4d_1 === Codes_CLOSED_ABNORMALLY_getInstance().r4d_1)) {
            this.n8_1 = 2;
            suspendResult = this.a4f_1.f4f_1.c4e().o1w(Close_init_$Create$(this.d4f_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.e4f_1 = Unit_instance;
          this.o8_1 = 6;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.o8_1 = 6;
          this.a4f_1.h4f_1.c1l(this.d4f_1);
          if (!(this.c4f_1 == null)) {
            this.a4f_1.j4f_1.u1w(this.c4f_1);
            this.a4f_1.i4f_1.u1w(this.c4f_1);
          }

          return Unit_instance;
        case 5:
          this.o8_1 = 6;
          var t = this.q8_1;
          this.a4f_1.h4f_1.c1l(this.d4f_1);
          if (!(this.c4f_1 == null)) {
            this.a4f_1.j4f_1.u1w(this.c4f_1);
            this.a4f_1.i4f_1.u1w(this.c4f_1);
          }

          throw t;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $checkMaxFrameSizeCOROUTINE$2(_this__u8e3s4, packet, frame, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.b4g_1 = _this__u8e3s4;
  this.c4g_1 = packet;
  this.d4g_1 = frame;
}
protoOf($checkMaxFrameSizeCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          var tmp_0 = this;
          var tmp_1 = this.d4g_1.a4i_1.length;
          var tmp0_safe_receiver = this.c4g_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_size(tmp0_safe_receiver);
          tmp_0.e4g_1 = tmp_1 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
          if (toLong(this.e4g_1).b1(this.b4g_1.a4e()) > 0) {
            var tmp2_safe_receiver = this.c4g_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.a4();
            }
            this.n8_1 = 2;
            suspendResult = close(this.b4g_1, CloseReason_init_$Create$(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + this.e4g_1 + '. Max size is ' + this.b4g_1.a4e().toString()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 1;
            continue $sm;
          }

        case 1:
          return Unit_instance;
        case 2:
          throw new FrameTooBigException(toLong(this.e4g_1));
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function DefaultWebSocketSessionImpl(raw, pingIntervalMillis, timeoutMillis) {
  Companion_getInstance_0();
  this.f4f_1 = raw;
  this.g4f_1 = atomic$ref$1(null);
  this.h4f_1 = CompletableDeferred();
  this.i4f_1 = Channel(8);
  this.j4f_1 = Channel(get_OUTGOING_CHANNEL_CAPACITY());
  this.k4f_1 = atomic$boolean$1(false);
  this.l4f_1 = Job(this.f4f_1.h1e().a9(Key_instance));
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.m4f_1 = ArrayList_init_$Create$();
  this.n4f_1 = atomic$boolean$1(false);
  this.o4f_1 = this.f4f_1.h1e().jg(this.l4f_1).jg(new CoroutineName('ws-default'));
  this.p4f_1 = pingIntervalMillis;
  this.q4f_1 = timeoutMillis;
  this.r4f_1 = this.h4f_1;
}
protoOf(DefaultWebSocketSessionImpl).b4e = function () {
  return this.i4f_1;
};
protoOf(DefaultWebSocketSessionImpl).c4e = function () {
  return this.j4f_1;
};
protoOf(DefaultWebSocketSessionImpl).f4g = function () {
  return this.m4f_1;
};
protoOf(DefaultWebSocketSessionImpl).h1e = function () {
  return this.o4f_1;
};
protoOf(DefaultWebSocketSessionImpl).z4d = function (value) {
  this.f4f_1.z4d(value);
};
protoOf(DefaultWebSocketSessionImpl).a4e = function () {
  return this.f4f_1.a4e();
};
protoOf(DefaultWebSocketSessionImpl).y4d = function (negotiatedExtensions) {
  if (!this.n4f_1.atomicfu$compareAndSet(false, true)) {
    // Inline function 'kotlin.error' call
    var message = 'WebSocket session ' + toString(this) + ' is already started.';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$0 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
    this_0.o3u(tmp$ret$0);
  }
  this.m4f_1.n(negotiatedExtensions);
  runOrCancelPinger(this);
  runIncomingProcessor(this, ponger(this, this.c4e()));
  runOutgoingProcessor(this);
};
protoOf(DefaultWebSocketSessionImpl).p3d = function ($completion) {
  return this.f4f_1.p3d($completion);
};
var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
function _init_properties_DefaultWebSocketSession_kt__469s0y() {
  if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
    properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
    LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
    IncomingProcessorCoroutineName = new CoroutineName('ws-incoming-processor');
    OutgoingProcessorCoroutineName = new CoroutineName('ws-outgoing-processor');
    NORMAL_CLOSE = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), 'OK');
  }
}
function readText_0(_this__u8e3s4) {
  // Inline function 'kotlin.require' call
  if (!_this__u8e3s4.y4h_1) {
    var message = 'Text could be only extracted from non-fragmented frame';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = Charsets_getInstance().n3n_1.r3n();
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  writeFully(builder, _this__u8e3s4.a4i_1);
  return decode(tmp, builder);
}
function NonDisposableHandle() {
}
protoOf(NonDisposableHandle).x1h = function () {
  return Unit_instance;
};
protoOf(NonDisposableHandle).toString = function () {
  return 'NonDisposableHandle';
};
protoOf(NonDisposableHandle).hashCode = function () {
  return 207988788;
};
protoOf(NonDisposableHandle).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NonDisposableHandle))
    return false;
  other instanceof NonDisposableHandle || THROW_CCE();
  return true;
};
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function readReason(_this__u8e3s4) {
  if (_this__u8e3s4.a4i_1.length < 2) {
    return null;
  }
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  writeFully(builder, _this__u8e3s4.a4i_1);
  var packet = builder;
  var code = packet.x38();
  var message = readText(packet);
  return new CloseReason(code, message);
}
function FrameTooBigException(frameSize) {
  Exception_init_$Init$(this);
  captureStack(this, FrameTooBigException);
  this.k4j_1 = frameSize;
}
protoOf(FrameTooBigException).g1 = function () {
  return 'Frame is too big: ' + this.k4j_1.toString();
};
protoOf(FrameTooBigException).n1l = function () {
  // Inline function 'kotlin.also' call
  var this_0 = new FrameTooBigException(this.k4j_1);
  initCauseBridge(this_0, this);
  return this_0;
};
var FrameType_TEXT_instance;
var FrameType_BINARY_instance;
var FrameType_CLOSE_instance;
var FrameType_PING_instance;
var FrameType_PONG_instance;
function Companion_1() {
  Companion_instance_1 = this;
  var tmp = this;
  var tmp0 = get_entries_0();
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxByOrNull' call
    var iterator = tmp0.j();
    if (!iterator.k()) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    var maxElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$0 = maxElem;
      break $l$block_0;
    }
    var maxValue = maxElem.o4j_1;
    do {
      var e = iterator.l();
      var v = e.o4j_1;
      if (compareTo(maxValue, v) < 0) {
        maxElem = e;
        maxValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$0 = maxElem;
  }
  tmp.p4j_1 = ensureNotNull(tmp$ret$0).o4j_1;
  var tmp_0 = this;
  var tmp_1 = 0;
  var tmp_2 = this.p4j_1 + 1 | 0;
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_3 = Array(tmp_2);
  while (tmp_1 < tmp_2) {
    var tmp_4 = tmp_1;
    var tmp1 = get_entries_0();
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.singleOrNull' call
      var single = null;
      var found = false;
      var _iterator__ex2g4s = tmp1.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.o4j_1 === tmp_4) {
          if (found) {
            tmp$ret$5 = null;
            break $l$block_2;
          }
          single = element;
          found = true;
        }
      }
      if (!found) {
        tmp$ret$5 = null;
        break $l$block_2;
      }
      tmp$ret$5 = single;
    }
    tmp_3[tmp_4] = tmp$ret$5;
    tmp_1 = tmp_1 + 1 | 0;
  }
  tmp_0.q4j_1 = tmp_3;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  FrameType_initEntries();
  if (Companion_instance_1 == null)
    new Companion_1();
  return Companion_instance_1;
}
function values_0() {
  return [FrameType_TEXT_getInstance(), FrameType_BINARY_getInstance(), FrameType_CLOSE_getInstance(), FrameType_PING_getInstance(), FrameType_PONG_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var FrameType_entriesInitialized;
function FrameType_initEntries() {
  if (FrameType_entriesInitialized)
    return Unit_instance;
  FrameType_entriesInitialized = true;
  FrameType_TEXT_instance = new FrameType('TEXT', 0, false, 1);
  FrameType_BINARY_instance = new FrameType('BINARY', 1, false, 2);
  FrameType_CLOSE_instance = new FrameType('CLOSE', 2, true, 8);
  FrameType_PING_instance = new FrameType('PING', 3, true, 9);
  FrameType_PONG_instance = new FrameType('PONG', 4, true, 10);
  Companion_getInstance_1();
}
var $ENTRIES_0;
function FrameType(name, ordinal, controlFrame, opcode) {
  Enum.call(this, name, ordinal);
  this.n4j_1 = controlFrame;
  this.o4j_1 = opcode;
}
function FrameType_TEXT_getInstance() {
  FrameType_initEntries();
  return FrameType_TEXT_instance;
}
function FrameType_BINARY_getInstance() {
  FrameType_initEntries();
  return FrameType_BINARY_instance;
}
function FrameType_CLOSE_getInstance() {
  FrameType_initEntries();
  return FrameType_CLOSE_instance;
}
function FrameType_PING_getInstance() {
  FrameType_initEntries();
  return FrameType_PING_instance;
}
function FrameType_PONG_getInstance() {
  FrameType_initEntries();
  return FrameType_PONG_instance;
}
function get_PongerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PongerCoroutineName;
}
var PongerCoroutineName;
function get_PingerCoroutineName() {
  _init_properties_PingPong_kt__9aqxey();
  return PingerCoroutineName;
}
var PingerCoroutineName;
function ponger(_this__u8e3s4, outgoing) {
  _init_properties_PingPong_kt__9aqxey();
  var channel = Channel(5);
  var tmp = get_PongerCoroutineName();
  launch(_this__u8e3s4, tmp, VOID, ponger$slambda_0(channel, outgoing, null));
  return channel;
}
function pinger(_this__u8e3s4, outgoing, periodMillis, timeoutMillis, onTimeout) {
  _init_properties_PingPong_kt__9aqxey();
  var actorJob = Job();
  var channel = Channel(2147483647);
  var tmp = actorJob.jg(get_PingerCoroutineName());
  launch(_this__u8e3s4, tmp, VOID, pinger$slambda_0(periodMillis, timeoutMillis, onTimeout, channel, outgoing, null));
  var tmp_0 = ensureNotNull(_this__u8e3s4.h1e().a9(Key_instance));
  tmp_0.k1f(pinger$lambda(actorJob));
  return channel;
}
function ponger$slambda($channel, $outgoing, resultContinuation) {
  this.z4j_1 = $channel;
  this.a4k_1 = $outgoing;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(ponger$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ponger$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(ponger$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          this.o8_1 = 13;
          var tmp_0 = this;
          tmp_0.c4k_1 = this.z4j_1;
          this.d4k_1 = this.c4k_1;
          var tmp_1 = this;
          tmp_1.e4k_1 = this.d4k_1;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.g4k_1 = this.e4k_1;
          this.h4k_1 = null;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          this.o8_1 = 10;
          this.o8_1 = 9;
          var tmp_2 = this;
          tmp_2.j4k_1 = this.g4k_1;
          this.k4k_1 = this.j4k_1;
          this.l4k_1 = this.k4k_1.j();
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.n8_1 = 5;
          suspendResult = this.l4k_1.v1t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          if (!suspendResult) {
            this.n8_1 = 7;
            continue $sm;
          }

          this.m4k_1 = this.l4k_1.l();
          var tmp_3 = this;
          tmp_3.n4k_1 = this.m4k_1;
          this.o4k_1 = this.n4k_1;
          get_LOGGER().o3u('Received ping message, sending pong message');
          this.n8_1 = 6;
          suspendResult = this.a4k_1.o1w(new Pong(this.o4k_1.a4i_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 6:
          this.n8_1 = 4;
          continue $sm;
        case 7:
          var tmp_4 = this;
          tmp_4.i4k_1 = Unit_instance;
          this.n8_1 = 8;
          var tmp_5 = this;
          continue $sm;
        case 8:
          this.o8_1 = 13;
          var tmp_6 = this;
          cancelConsumed(this.g4k_1, this.h4k_1);
          tmp_6.f4k_1 = Unit_instance;
          this.n8_1 = 12;
          continue $sm;
        case 9:
          this.o8_1 = 10;
          var tmp_7 = this.q8_1;
          if (tmp_7 instanceof Error) {
            var e = this.q8_1;
            var tmp_8 = this;
            this.h4k_1 = e;
            throw e;
          } else {
            throw this.q8_1;
          }

        case 10:
          this.o8_1 = 13;
          var t = this.q8_1;
          cancelConsumed(this.g4k_1, this.h4k_1);
          throw t;
        case 11:
          this.o8_1 = 13;
          cancelConsumed(this.g4k_1, this.h4k_1);
          if (false) {
            this.n8_1 = 1;
            continue $sm;
          }

          this.n8_1 = 12;
          continue $sm;
        case 12:
          this.o8_1 = 14;
          this.n8_1 = 15;
          continue $sm;
        case 13:
          this.o8_1 = 14;
          var tmp_9 = this.q8_1;
          if (tmp_9 instanceof ClosedSendChannelException) {
            var _unused_var__etf5q3 = this.q8_1;
            this.n8_1 = 15;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 14:
          throw this.q8_1;
        case 15:
          this.o8_1 = 14;
          return Unit_instance;
      }
    } catch ($p) {
      var e_0 = $p;
      if (this.o8_1 === 14) {
        throw e_0;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_0;
      }
    }
   while (true);
};
protoOf(ponger$slambda).s3m = function ($this$launch, completion) {
  var i = new ponger$slambda(this.z4j_1, this.a4k_1, completion);
  i.b4k_1 = $this$launch;
  return i;
};
function ponger$slambda_0($channel, $outgoing, resultContinuation) {
  var i = new ponger$slambda($channel, $outgoing, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function pinger$slambda$slambda($channel, resultContinuation) {
  this.x4k_1 = $channel;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(pinger$slambda$slambda).r3m = function ($this$withTimeoutOrNull, $completion) {
  var tmp = this.s3m($this$withTimeoutOrNull, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(pinger$slambda$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(pinger$slambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.n8_1 = 4;
            continue $sm;
          }

          this.n8_1 = 2;
          suspendResult = this.x4k_1.s1w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.n8_1 = 1;
          continue $sm;
        case 3:
          throw this.q8_1;
        case 4:
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(pinger$slambda$slambda).s3m = function ($this$withTimeoutOrNull, completion) {
  var i = new pinger$slambda$slambda(this.x4k_1, completion);
  i.y4k_1 = $this$withTimeoutOrNull;
  return i;
};
function pinger$slambda$slambda_0($channel, resultContinuation) {
  var i = new pinger$slambda$slambda($channel, resultContinuation);
  var l = function ($this$withTimeoutOrNull, $completion) {
    return i.r3m($this$withTimeoutOrNull, $completion);
  };
  l.$arity = 1;
  return l;
}
function pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation) {
  this.h4l_1 = $outgoing;
  this.i4l_1 = $pingMessage;
  this.j4l_1 = $channel;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(pinger$slambda$slambda_1).r3m = function ($this$withTimeoutOrNull, $completion) {
  var tmp = this.s3m($this$withTimeoutOrNull, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(pinger$slambda$slambda_1).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(pinger$slambda$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          get_LOGGER().o3u('WebSocket Pinger: sending ping frame');
          this.n8_1 = 1;
          suspendResult = this.h4l_1.o1w(new Ping(toByteArray(this.i4l_1, Charsets_getInstance().o3n_1)), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!true) {
            this.n8_1 = 5;
            continue $sm;
          }

          this.n8_1 = 3;
          suspendResult = this.j4l_1.s1w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          var msg = suspendResult;
          if (decodeToString(msg.a4i_1, 0, 0 + msg.a4i_1.length | 0) === this.i4l_1) {
            get_LOGGER().o3u('WebSocket Pinger: received valid pong frame ' + msg.toString());
            this.n8_1 = 5;
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 4:
          get_LOGGER().o3u('WebSocket Pinger: received invalid pong frame ' + msg.toString() + ', continue waiting');
          this.n8_1 = 2;
          continue $sm;
        case 5:
          return Unit_instance;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(pinger$slambda$slambda_1).s3m = function ($this$withTimeoutOrNull, completion) {
  var i = new pinger$slambda$slambda_1(this.h4l_1, this.i4l_1, this.j4l_1, completion);
  i.k4l_1 = $this$withTimeoutOrNull;
  return i;
};
function pinger$slambda$slambda_2($outgoing, $pingMessage, $channel, resultContinuation) {
  var i = new pinger$slambda$slambda_1($outgoing, $pingMessage, $channel, resultContinuation);
  var l = function ($this$withTimeoutOrNull, $completion) {
    return i.r3m($this$withTimeoutOrNull, $completion);
  };
  l.$arity = 1;
  return l;
}
function pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
  this.t4l_1 = $periodMillis;
  this.u4l_1 = $timeoutMillis;
  this.v4l_1 = $onTimeout;
  this.w4l_1 = $channel;
  this.x4l_1 = $outgoing;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(pinger$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(pinger$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(pinger$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 9;
          get_LOGGER().o3u('Starting WebSocket pinger coroutine with period ' + this.t4l_1.toString() + ' ms and timeout ' + this.u4l_1.toString() + ' ms');
          this.z4l_1 = Random(getTimeMillis());
          this.a4m_1 = new Int8Array(32);
          this.o8_1 = 7;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.n8_1 = 6;
            continue $sm;
          }

          this.n8_1 = 2;
          suspendResult = withTimeoutOrNull(this.t4l_1, pinger$slambda$slambda_0(this.w4l_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.z4l_1.qh(this.a4m_1);
          this.b4m_1 = '[ping ' + hex(this.a4m_1) + ' ping]';
          this.n8_1 = 3;
          suspendResult = withTimeoutOrNull(this.u4l_1, pinger$slambda$slambda_2(this.x4l_1, this.b4m_1, this.w4l_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.c4m_1 = suspendResult;
          if (this.c4m_1 == null) {
            get_LOGGER().o3u('WebSocket pinger has timed out');
            this.n8_1 = 5;
            suspendResult = this.v4l_1(CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), 'Ping timeout'), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 4:
          this.n8_1 = 1;
          continue $sm;
        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.o8_1 = 9;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          this.o8_1 = 9;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof CancellationException) {
            var ignore = this.q8_1;
            this.n8_1 = 8;
            continue $sm;
          } else {
            var tmp_1 = this.q8_1;
            if (tmp_1 instanceof ClosedReceiveChannelException) {
              var ignore_0 = this.q8_1;
              this.n8_1 = 8;
              continue $sm;
            } else {
              var tmp_2 = this.q8_1;
              if (tmp_2 instanceof ClosedSendChannelException) {
                var ignore_1 = this.q8_1;
                this.n8_1 = 8;
                continue $sm;
              } else {
                var tmp_3 = this.q8_1;
                if (tmp_3 instanceof ClosedByteChannelException) {
                  var ignore_2 = this.q8_1;
                  this.n8_1 = 8;
                  continue $sm;
                } else {
                  throw this.q8_1;
                }
              }
            }
          }

        case 8:
          this.o8_1 = 9;
          return Unit_instance;
        case 9:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 9) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(pinger$slambda).s3m = function ($this$launch, completion) {
  var i = new pinger$slambda(this.t4l_1, this.u4l_1, this.v4l_1, this.w4l_1, this.x4l_1, completion);
  i.y4l_1 = $this$launch;
  return i;
};
function pinger$slambda_0($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation) {
  var i = new pinger$slambda($periodMillis, $timeoutMillis, $onTimeout, $channel, $outgoing, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function pinger$lambda($actorJob) {
  return function (it) {
    $actorJob.s1f();
    return Unit_instance;
  };
}
var properties_initialized_PingPong_kt_fbfhmc;
function _init_properties_PingPong_kt__9aqxey() {
  if (!properties_initialized_PingPong_kt_fbfhmc) {
    properties_initialized_PingPong_kt_fbfhmc = true;
    PongerCoroutineName = new CoroutineName('ws-ponger');
    PingerCoroutineName = new CoroutineName('ws-pinger');
  }
}
function WebSocketExtension() {
}
function WebSocketExtensionsConfig() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.f4m_1 = ArrayList_init_$Create$();
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp_0.g4m_1 = [false, false, false];
}
protoOf(WebSocketExtensionsConfig).r2f = function () {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.f4m_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = item();
    destination.e(tmp$ret$0);
  }
  return destination;
};
function parametersToString($this) {
  return $this.i4m_1.p() ? '' : '; ' + joinToString($this.i4m_1, ';');
}
function WebSocketExtensionHeader(name, parameters) {
  this.h4m_1 = name;
  this.i4m_1 = parameters;
}
protoOf(WebSocketExtensionHeader).toString = function () {
  return this.h4m_1 + ' ' + parametersToString(this);
};
function parseWebSocketExtensions(value) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = split(value, [',']);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var extension = split(item, [';']);
    // Inline function 'kotlin.text.trim' call
    var this_1 = first(extension);
    var name = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'kotlin.collections.map' call
    var this_2 = drop(extension, 1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$_0(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_0 = this_2.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$2 = toString(trim(isCharSequence(item_0) ? item_0 : THROW_CCE()));
      destination_0.e(tmp$ret$2);
    }
    var parameters = destination_0;
    var tmp$ret$5 = new WebSocketExtensionHeader(name, parameters);
    destination.e(tmp$ret$5);
  }
  return destination;
}
function send_0(_this__u8e3s4, content, $completion) {
  return _this__u8e3s4.d4e(Text_init_$Create$(content), $completion);
}
function close(_this__u8e3s4, reason, $completion) {
  reason = reason === VOID ? CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '') : reason;
  var tmp = new $closeCOROUTINE$3(_this__u8e3s4, reason, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function WebSocketSession() {
}
function closeExceptionally(_this__u8e3s4, cause, $completion) {
  var tmp;
  if (cause instanceof CancellationException) {
    tmp = CloseReason_init_$Create$(Codes_NORMAL_getInstance(), '');
  } else {
    tmp = CloseReason_init_$Create$(Codes_INTERNAL_ERROR_getInstance(), cause.toString());
  }
  var reason = tmp;
  return close(_this__u8e3s4, reason, $completion);
}
function $closeCOROUTINE$3(_this__u8e3s4, reason, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.r4m_1 = _this__u8e3s4;
  this.s4m_1 = reason;
}
protoOf($closeCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.r4m_1.d4e(Close_init_$Create$(this.s4m_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.n8_1 = 2;
          suspendResult = this.r4m_1.p3d(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.o8_1 = 4;
          this.n8_1 = 5;
          continue $sm;
        case 3:
          this.o8_1 = 4;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof Error) {
            var _unused_var__etf5q3 = this.q8_1;
            this.n8_1 = 5;
            continue $sm;
          } else {
            throw this.q8_1;
          }

        case 4:
          throw this.q8_1;
        case 5:
          this.o8_1 = 4;
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function Binary_init_$Init$(fin, data, $this) {
  Binary.call($this, fin, data, false, false, false);
  return $this;
}
function Binary_init_$Create$(fin, data) {
  return Binary_init_$Init$(fin, data, objectCreate(protoOf(Binary)));
}
function Text_init_$Init$(fin, data, $this) {
  Text.call($this, fin, data, false, false, false);
  return $this;
}
function Text_init_$Init$_0(text, $this) {
  Text_init_$Init$(true, toByteArray(text), $this);
  return $this;
}
function Text_init_$Create$(text) {
  return Text_init_$Init$_0(text, objectCreate(protoOf(Text)));
}
function Close_init_$Init$(reason, $this) {
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  builder.f3a(reason.v4d_1);
  writeText(builder, reason.w4d_1);
  Close_init_$Init$_0(builder, $this);
  return $this;
}
function Close_init_$Create$(reason) {
  return Close_init_$Init$(reason, objectCreate(protoOf(Close)));
}
function Close_init_$Init$_0(packet, $this) {
  Close.call($this, readByteArray(packet));
  return $this;
}
function Close_init_$Init$_1($this) {
  Close.call($this, Companion_getInstance_2().f4i_1);
  return $this;
}
function Close_init_$Create$_0() {
  return Close_init_$Init$_1(objectCreate(protoOf(Close)));
}
function Binary(fin, data, rsv1, rsv2, rsv3) {
  rsv1 = rsv1 === VOID ? false : rsv1;
  rsv2 = rsv2 === VOID ? false : rsv2;
  rsv3 = rsv3 === VOID ? false : rsv3;
  Frame.call(this, fin, FrameType_BINARY_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
}
function Text(fin, data, rsv1, rsv2, rsv3) {
  rsv1 = rsv1 === VOID ? false : rsv1;
  rsv2 = rsv2 === VOID ? false : rsv2;
  rsv3 = rsv3 === VOID ? false : rsv3;
  Frame.call(this, fin, FrameType_TEXT_getInstance(), data, NonDisposableHandle_instance, rsv1, rsv2, rsv3);
}
function Close(data) {
  Frame.call(this, true, FrameType_CLOSE_getInstance(), data, NonDisposableHandle_instance, false, false, false);
}
function Ping(data) {
  Frame.call(this, true, FrameType_PING_getInstance(), data, NonDisposableHandle_instance, false, false, false);
}
function Pong(data, disposableHandle) {
  disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
  Frame.call(this, true, FrameType_PONG_getInstance(), data, disposableHandle, false, false, false);
}
function Companion_2() {
  Companion_instance_2 = this;
  this.f4i_1 = new Int8Array(0);
}
protoOf(Companion_2).g4i = function (fin, frameType, data, rsv1, rsv2, rsv3) {
  var tmp;
  switch (frameType.l2_1) {
    case 1:
      tmp = new Binary(fin, data, rsv1, rsv2, rsv3);
      break;
    case 0:
      tmp = new Text(fin, data, rsv1, rsv2, rsv3);
      break;
    case 2:
      tmp = new Close(data);
      break;
    case 3:
      tmp = new Ping(data);
      break;
    case 4:
      tmp = new Pong(data, NonDisposableHandle_instance);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 == null)
    new Companion_2();
  return Companion_instance_2;
}
function Frame(fin, frameType, data, disposableHandle, rsv1, rsv2, rsv3) {
  Companion_getInstance_2();
  disposableHandle = disposableHandle === VOID ? NonDisposableHandle_instance : disposableHandle;
  rsv1 = rsv1 === VOID ? false : rsv1;
  rsv2 = rsv2 === VOID ? false : rsv2;
  rsv3 = rsv3 === VOID ? false : rsv3;
  this.y4h_1 = fin;
  this.z4h_1 = frameType;
  this.a4i_1 = data;
  this.b4i_1 = disposableHandle;
  this.c4i_1 = rsv1;
  this.d4i_1 = rsv2;
  this.e4i_1 = rsv3;
}
protoOf(Frame).toString = function () {
  return 'Frame ' + this.z4h_1.toString() + ' (fin=' + this.y4h_1 + ', buffer len = ' + this.a4i_1.length + ')';
};
function get_OUTGOING_CHANNEL_CAPACITY() {
  return 8;
}
//region block: post-declaration
protoOf(DefaultWebSocketSessionImpl).d4e = send;
defineProp(protoOf(FrameTooBigException), 'message', function () {
  return this.g1();
});
//endregion
//region block: init
NonDisposableHandle_instance = new NonDisposableHandle();
//endregion
//region block: exports
export {
  Codes_CLOSED_ABNORMALLY_getInstance as Codes_CLOSED_ABNORMALLY_getInstance3jfmk899ruwbw,
  Codes_NORMAL_getInstance as Codes_NORMAL_getInstance1ncoyj30a5q91,
  send as send21jve17yf7nem,
  close as close3ib01rkluotvx,
  send_0 as send1w8fi67yxo60d,
  Binary_init_$Create$ as Binary_init_$Create$1kqm3maz76dye,
  Close_init_$Create$ as Close_init_$Create$xnslhx6b2vkg,
  Text_init_$Create$ as Text_init_$Create$2ts7fidz9bnzk,
  Companion_getInstance as Companion_getInstance3khafte9uwg7t,
  CloseReason as CloseReason10cphaqpp3ct7,
  DefaultWebSocketSession_0 as DefaultWebSocketSession2pi4wuih6mkcj,
  DefaultWebSocketSession as DefaultWebSocketSession3h8506yqzs5fx,
  Text as Text3e6ukp9joohql,
  WebSocketExtensionsConfig as WebSocketExtensionsConfig3sf1f7u7xi63m,
  WebSocketExtension as WebSocketExtensionixqq2y77p4e0,
  WebSocketSession as WebSocketSessionzi1ianvyj32u,
  parseWebSocketExtensions as parseWebSocketExtensionszyo25w86ylog,
  readText_0 as readText30p9xkeoodw49,
};
//endregion

